import React, { createContext, useContext, useState, ReactNode } from 'react';

interface ComparisonContextType {
  comparedCars: any[];
  addToComparison: (car: any) => void;
  removeFromComparison: (carId: string) => void;
  clearComparison: () => void;
  isComparing: (carId: string) => boolean;
}

const ComparisonContext = createContext<ComparisonContextType | undefined>(undefined);

export const useComparison = () => {
  const context = useContext(ComparisonContext);
  if (!context) {
    throw new Error('useComparison must be used within ComparisonProvider');
  }
  return context;
};

export const ComparisonProvider = ({ children }: { children: ReactNode }) => {
  const [comparedCars, setComparedCars] = useState<any[]>([]);

  const addToComparison = (car: any) => {
    if (comparedCars.length >= 3) {
      return; // Max 3 cars
    }
    if (!comparedCars.find(c => c.id === car.id)) {
      setComparedCars([...comparedCars, car]);
    }
  };

  const removeFromComparison = (carId: string) => {
    setComparedCars(comparedCars.filter(c => c.id !== carId));
  };

  const clearComparison = () => {
    setComparedCars([]);
  };

  const isComparing = (carId: string) => {
    return comparedCars.some(c => c.id === carId);
  };

  return (
    <ComparisonContext.Provider
      value={{
        comparedCars,
        addToComparison,
        removeFromComparison,
        clearComparison,
        isComparing,
      }}
    >
      {children}
    </ComparisonContext.Provider>
  );
};
